import { useEffect, useCallback, useRef } from "react";
import NotificationAlert from "./NotificationAlert";
import { getToken } from "firebase/messaging";
import { messaging, getMessagingInstance } from "../../config/firebaseConfig";
import { useFormData } from "../../helper/FormDataProvider";
import useLandingAuthApi from "../../services/api/useLandingAuthApi";

const NotificationHandler = () => {
  const { userData } = useFormData();
  const { addDeviceToken } = useLandingAuthApi();
  const initializationAttempted = useRef(false);

  const initializeNotifications = useCallback(async () => {
    if (initializationAttempted.current) return;
    initializationAttempted.current = true;

    try {
      // Wait for messaging to be initialized
      let messagingInstance = messaging;
      if (!messagingInstance) {
        messagingInstance = await getMessagingInstance();
      }

      if (!messagingInstance) {
        console.warn("Firebase Cloud Messaging is not available");
        return;
      }

      const permission = await Notification.requestPermission();

      if (permission === "granted") {
        let token;
        try {
          if (process.env.NODE_ENV === "production") {
            token = await getToken(messagingInstance, {
              vapidKey: `REACT_APP_VAPID_KEY_PLACEHOLDER`,
            });
          } else {
            token = await getToken(messagingInstance, {
              vapidKey: process.env.REACT_APP_VAPID_KEY,
            });
          }
        } catch (tokenError) {
          console.error("Error generating FCM token:", tokenError);
          return;
        }

        if (token) {
          try {
            await addDeviceToken(token);
          } catch (error) {
            console.error("Error registering device token:", error);
          }
        }
      } else {
        console.warn("Notification permission not granted:", permission);
      }
    } catch (error) {
      console.error("Error initializing notifications:", error);
    }
  }, [addDeviceToken]);

  useEffect(() => {
    if (userData?.data?.id && !initializationAttempted.current) {
      initializeNotifications();
    }
  }, [userData?.data?.id, initializeNotifications]);

  return <NotificationAlert />;
};

export default NotificationHandler;
